import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './websiteV2.css';
import { WEBSITE_V2_BODY } from './websiteV2Body';
import { initWebsiteV2, type WebsiteV2Page } from './websiteV2Init';

/** The public site: a short scroll film on the home page plus a page per product, plans and about. */
export default function WebsiteV2({ page = 'home' }: { page?: WebsiteV2Page }) {
  const ref = useRef<HTMLDivElement>(null);
  const api = useRef<ReturnType<typeof initWebsiteV2> | null>(null);
  const navigate = useNavigate();
  const pageRef = useRef(page);
  pageRef.current = page;
  useEffect(() => {
    if (!ref.current) return;
    api.current = initWebsiteV2(ref.current, navigate);
    api.current.setPage(pageRef.current);
    return () => { api.current?.cleanup(); api.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => { api.current?.setPage(page); }, [page]);
  return <div className="mwv2" lang="en" ref={ref} dangerouslySetInnerHTML={{ __html: WEBSITE_V2_BODY }} />;
}
